/* eslint-disable no-console */
import { mapFieldToERP } from '@/js/mappers/field';
import FarmerRepository from '@/js/repositories/farmerRepository';
import FieldRepository from '@/js/repositories/fieldRepository';
import {
  removeField,
  saveField,
} from '@/js/services/contracts/ApiContractsWs';

export default {
  async add(object) {
    await FieldRepository.add(object);
    return object;
  },

  async updateById(id, objeto) {
    return FieldRepository.updateById(id, objeto);
  },

  async deleteById(id) {
    const field = await this.getById(id);
    if (!field.id_external || field.id_external <= 0) {
      return FieldRepository.deleteById(id);
    }
    field.sync_status = 2;
    return this.updateById(id, field);
  },

  async multipleDeleteByKey(items, key) {
    for await (const element of items) {
      await FieldRepository.deleteByProperty(key, element.Codigo);
    }
  },

  async getById(id) {
    return FieldRepository.getById(id);
  },

  async getByCode(code) {
    return FieldRepository.getByCode(code);
  },

  async getByIdFull(id) {
    return FieldRepository.getByIdFull(id);
  },

  async getAll() {
    return FieldRepository.getAll();
  },

  async getAllSyncPending() {
    const syncFields = await FieldRepository.getAllSyncPending();
    for await (const field of syncFields) {
      const farmer = await FarmerRepository.getById(field.farmer);
      field.farmer = farmer;
    }

    return syncFields;
  },

  async saveFieldToERP(field) {
    const fieldERP = mapFieldToERP(field);
    return saveField(fieldERP).then(async (response) => {
      if (response.data.Valor) {
        const responseObject = JSON.parse(response.data.Tag);
        if (field.code !== '') {
          await this.updateById(field.id, { id_external: responseObject.Id, sync_status: 0, sync_error_msg: '' });
        } else {
          await this.deleteById(field.id);
        }
      } else {
        console.log('error adding field erp', field, response.data.Mensaje);
        await this.updateById(field.id, { sync_error_msg: response.data.Mensaje });
      }
    }).catch(async (error) => {
      console.log('error adding field erp', field, error);
      await this.updateById(field.id, { sync_error_msg: error });
    });
  },

  async removeFieldFromERP(field) {
    return removeField(field).then(async (response) => {
      if (response.data.Valor) {
        await FieldRepository.deleteById(field.id);
      } else {
        console.log('error removing field erp', field, response.data.Mensaje);
        await this.updateById(field.id, { sync_error_msg: response.data.Mensaje });
      }
    }).catch(async (error) => {
      console.log('error removing field erp', field, error);
      await this.updateById(field.id, { sync_error_msg: error });
    });
  },

  async syncPendingFields() {
    const syncFields = await this.getAllSyncPending();
    for await (const field of syncFields) {
      if (field.sync_status === 1) {
        await this.saveFieldToERP(field);
      } else if (field.sync_status === 2) {
        await this.removeFieldFromERP(field);
      }
    }
    /* await syncFields.forEach(async (field) => {
      await this.saveFieldToERP(field);
    }); */
  },

  async getAllPrimaryKeys() {
    const fields = await FieldRepository.getAllAlreadySync();
    return fields.map((f) => f.code);
  },
};
